var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6889 0.284493L0.974174 11.2763C0.785986 11.4694 0.680664 11.7283 0.680664 11.9979C0.680664 12.2675 0.785986 12.5265 0.974174 12.7196L11.6889 23.7155C11.7766 23.8055 11.8814 23.8771 11.9972 23.926C12.1129 23.9748 12.2373 24 12.363 24C12.4886 24 12.613 23.9748 12.7288 23.926C12.8446 23.8771 12.9494 23.8055 13.0371 23.7155C13.2174 23.5309 13.3184 23.283 13.3184 23.0249C13.3184 22.7668 13.2174 22.5189 13.0371 22.3343L2.96122 11.9979L13.0371 1.66364C13.2168 1.47909 13.3174 1.23167 13.3174 0.974066C13.3174 0.716463 13.2168 0.469038 13.0371 0.284493C12.9494 0.194459 12.8446 0.122899 12.7288 0.0740364C12.613 0.0251741 12.4886 0 12.363 0C12.2373 0 12.1129 0.0251741 11.9972 0.0740364C11.8814 0.122899 11.7766 0.194459 11.6889 0.284493Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.350bdc8cf755b78f539c89dbcf9812bf.svg";
export { ForwardRef as ReactComponent };